import _ from 'underscore';
import { createSelector } from 'reselect';
import scheduledMeetingsSelector from './scheduled_meetings_selector';
import teachersSelector from './teachers_selector';
import Time from '../lib/time';

const _meetingsDoNotIntersect = (inspectedMeeting, teacherScheduledMeeting) =>
  teacherScheduledMeeting.day_of_week !== inspectedMeeting.day_of_week ||
    Time.parse(teacherScheduledMeeting.end_time).totalMinutes <= Time.parse(inspectedMeeting.start_time).totalMinutes ||
    Time.parse(teacherScheduledMeeting.start_time).totalMinutes >= Time.parse(inspectedMeeting.end_time).totalMinutes

const _scheduledMeetingsForTeacher = (teacher, state) =>
  _.chain(teacher.scheduled_meeting_ids)
    .map(id => {
      return state.scheduledMeetings.entities[id];
    })
    .select(scheduledMeeting => {
      return scheduledMeeting && scheduledMeeting.meeting_id && scheduledMeeting.name !== 'Available';
    })
    .value();

const availableStaffSelector = createSelector(
  state => state,
  state => scheduledMeetingsSelector.getInspected(state),
  (state, scheduledMeetings) => {
    let availableStaff = _.chain(teachersSelector.getAll(state))
      .select(teacher => {
        let teacherScheduledMeetings = _scheduledMeetingsForTeacher(teacher, state);
        return _.all(scheduledMeetings, inspectedMeeting =>
          _.all(teacherScheduledMeetings, teacherScheduledMeeting =>
            _meetingsDoNotIntersect(inspectedMeeting, teacherScheduledMeeting)
          )
        );
      })
      .map(teacher => Object.assign(teacher, { availability: "full" }))
      .value()

    // temporary hack to demonstrate partial availability display
    // (we're not calculating partial availability yet)
    if(availableStaff.length > 0) {
      availableStaff[availableStaff.length - 1].availability = "partial";  
    }
    
    return availableStaff;
  }
);

export default availableStaffSelector;


/** WEBPACK FOOTER **
 ** ./src/js/selectors/available_staff_selector.js
 **/